import { Cords } from './types';

const INITIAL_CORDS: Cords = {
  st: 0,
  x: 0,
  y: 0,
} as const;

export { INITIAL_CORDS };
